import React, { memo } from 'react'
import InputBase from '@material-ui/core/InputBase'

import { useArticleState } from '../../../reducer'
import { TArticleTextfieldProps } from 'models'

const TextField: React.FunctionComponent<TArticleTextfieldProps> = ({
	name,
	placeholder,
	className,
	hasError,
}) => {
	const [state, dispatch] = useArticleState()
	const { [name]: value } = state
	const setValue = (e: React.ChangeEvent<HTMLInputElement>) => {
		dispatch({
			type: 'set_' + name,
			[name]: e.target.value,
		})
	}

	return (
		<InputBase
			fullWidth
			placeholder={placeholder}
			rows={1}
			className={className}
			onChange={setValue}
			value={value}
		/>
	)
}

export default memo(TextField)
